// src/components/Careers/LearnMore/LearnMore.js
import React from 'react';
import './LearnMore.css';

function LearnMore() {
  return (
    <section className="learn-more-section">
      <div className="learn-more-content">
        <h2 className="learn-more-title">Learn more about Sendbird</h2>
        <a href="/about" className="learn-more-button">About Sendbird</a>
      </div>
    </section>
  );
}

export default LearnMore;